<h3 style="text-align: center;">{{ isEditing ? 'Modifier' : 'Créer' }} une catégorie</h3>

<mat-form-field appearance="fill" style="width: 100%; margin-bottom: 4px;">
  <mat-label>Nom de la catégorie (WinMedia)</mat-label>
  <input matInput [(ngModel)]="label" required>
  <mat-hint *ngIf="!isDuplicate()">Nom écrit exactement comme dans WinMedia</mat-hint>
  <mat-hint *ngIf="isDuplicate()" style="color: #f44336; font-weight:bold;">Une catégorie avec ce nom existe déjà.</mat-hint>
</mat-form-field>

<div style="margin-bottom: 10px; display: flex; align-items: center; gap: 12px;">
  <mat-slide-toggle [(ngModel)]="importSons" color="primary">
    Import sons
  </mat-slide-toggle>
  <span style="color: #666; font-size: 0.85em;">Proposée dans la liste de la table "Sons"</span>
</div>

<div style="margin-bottom: 10px; display: flex; align-items: center; gap: 12px;">
  <mat-slide-toggle [(ngModel)]="preselectPlaylist" color="primary">
    PréSélection playlist
  </mat-slide-toggle>
  <span style="color: #666; font-size: 0.85em;">Proposée dans la page PréSélection catégories</span>
</div>

<div style="margin-bottom: 20px; display: flex; align-items: center; gap: 12px;">
  <mat-slide-toggle [(ngModel)]="editWinmediaFlag" color="primary">
    Édition WinMedia
  </mat-slide-toggle>
<span style="color: #666; font-size: 0.85em;">Proposée dans la page Édition WinMedia</span>
</div>

<div style="margin-top: 20px; display: flex; gap: 8px; flex-wrap: wrap;">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaveDisabled()">
    Enregistrer
  </button>
  <button *ngIf="isEditing" mat-raised-button color="warn" (click)="delete()" style="margin-left: auto;">
    Supprimer
  </button>
</div>
